import { DialogType } from '@tableau/widgets';
import React = require('react');

import { Messages } from '~src/codegen/Localize';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { ModalInstance, ReactModalService } from '../../../../commonInfra/dialogs/ReactModalService';
import { EditGroupDialog } from '../../components/editGroup/EditGroupDialog';
import { IGroupInfo } from '../../models/IGroupInfo';

function showEditGroupDialog(group: IGroupInfo): Promise<any> {
  let modalInstance: ModalInstance;
  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
    close: (result: any) => modalInstance && modalInstance.close(result),
    groupInfo: group
  };

  modalInstance = ReactModalService.open({
    type: DialogType.NormalWithTitleBar,
    dialogContent: React.createElement(EditGroupDialog, dialogProps),
    testId: 'editGroup',
    showCloseButton: true,
    dialogBodyStyle: {overflow: 'hidden'},
    dialogWidth: TabDialogWidth.width650px,
    title: Messages.editGroup_title()
  });

  return Promise.resolve(modalInstance.result);
}

export const EditGroupDialogAction = {
    showEditGroupDialog
};
